import React from 'react';
import { IProps } from './types';
import _ from 'lodash';

const FireInsureRules: React.FC<IProps> = (props) => {
  /**
   * @description 建立左側標頭 (手機版)
   */
  const handleCreateTitleMobile = (lmtContent:any) => {
    const titles = new Array(0);
    _.forEach(lmtContent, (content:string[]) => {
      if (!content[0]) return;

      titles.push(content[0]);
    });

    return _.map(titles, (str:string, index:number) => {
      return <div className="element__table-horizon-y-title" key={index}>{str}</div>;
    });
  };

  /**
   * @description 建立投保規則內容區塊
   * @param lmt 表格內容資料
   * @param thIs1st 表格內容 (非標頭) 第一個標籤是否為 th，預設為 false
  */
  const handleCreateLmtContent = (lmt:string[][], thIs1st:boolean = false) => {
    let title;
    const childs = new Array(0);
    _.forEach(lmt, (lmtContents:string[], index:number) => {
      // 第一筆陣列資料為標頭
      if (index === 0) {
        title = (
          <tr key={index}>
            {
              _.map(lmtContents, (content:string, contentIndex:number) => {
                return <th className="element__table-horizon-x-title" key={contentIndex}>{content}</th>;
              })
            }
          </tr>
        );
        return;
      }

      // 建立表單內容，判斷第一個標籤是否為 th
      const child = _.map(lmtContents, (content:string, contentIndex:number) => {
        if (thIs1st && contentIndex === 0) return <th className="element__table-horizon-y-title" key={contentIndex}>{content}</th>;
        if (content && content.toUpperCase() === 'V') {
          return (
            <td key={contentIndex}>
              <i className="element__tick-icon" />
            </td>
          );
        }
        return <td key={contentIndex}>{content}</td>;
      });

      childs.push(
        <tr key={index}>
          {child}
        </tr>
      );
    });

    return (
      <>
        {title}
        {childs}
      </>
    );
  };

  return (
    <div className="fire-insure-rules">
      {
        props.frprodLmt && props.frprodLmt[0] && props.frprodLmt[0].length > 0 && (
          <div className="fire-insure-rules__table-1st">
            <table>
              <tbody>
                {
                  handleCreateLmtContent(props.frprodLmt)
                }
              </tbody>
            </table>
          </div>
        )
      }
      {
        props.frbcLmt && props.frbcLmt[0] && props.frbcLmt[0].length > 0 && (
          <div className="fire-insure-rules__table-2nd">
            <div className="fire-insure-rules__table-2nd__table-title">網路投保 VS 網路要保</div>
            <div className="element__table-horizon">
              <div className="element__table-horizon-y-fixed">
                {handleCreateTitleMobile(props.frbcLmt)}
              </div>
              <div className="element__table-horizon-wrap">
                <div className="element__table-horizon-container">
                  <table>
                    <tbody>
                      {
                        handleCreateLmtContent(props.frbcLmt, true)
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default FireInsureRules;
